import React from 'react'

import { ArrowNext, ArrowPrev } from './styles/Arrow'
import { ArrowWrapper } from './styles/ArrowWrapper'

interface Props {
  slidesAmount: number
  isTransitioning: boolean
  arrowClickHandler: (direction: string) => void
}

export function Arrows({ slidesAmount, isTransitioning, arrowClickHandler }: Props) {
  if (slidesAmount <= 1) {
    return null
  }

  return (
    <>
      <ArrowWrapper
        className={'prev-wrapper'}
        onClick={() => (!isTransitioning ? arrowClickHandler('prev') : null)}
        left
      >
        <ArrowPrev className="arrow-icon" />
      </ArrowWrapper>
      <ArrowWrapper
        className={'next-wrapper'}
        left={false}
        onClick={() => (!isTransitioning ? arrowClickHandler('next') : null)}
      >
        <ArrowNext className="arrow-icon" />
      </ArrowWrapper>
    </>
  )
}
